import React from 'react'
import { Alert, Button, Card, Form, Input } from 'antd'
import { useAutoFocusFirstInput } from '../../../../../hooks/useAutoFocusFirstInput'
import { useCreateOrganizationMutation } from '../../../../store/apis/organization.api'
import { openNotificationWithIcon } from '../../../../utils/notification.helper'

const CreateOrganizationCard = () => {
    const [form] = Form.useForm()
    useAutoFocusFirstInput()

    const [createOrganization, { isLoading, error }] = useCreateOrganizationMutation()

    const handleCreateOrganization = async () => {
        const response = await createOrganization({name: form.getFieldValue('name')})
        if ('data' in response) {
            openNotificationWithIcon('success', 'Organization created successfully')
            form.resetFields()
        }
    }

    return (
        <Card title='Create Organization' bordered={false} className='mb-32'>
            <Form
                form={form}
                name='createOrganization'
                onFinish={handleCreateOrganization}
                layout='vertical'
                requiredMark={false}
                validateTrigger={['onBlur', 'onSubmit']}
            >
                <Form.Item
                    label='Name'
                    name='name'
                    rules={[{ required: true, message: 'Please, enter organization name' }]}
                >
                    <Input />
                </Form.Item>
                {error && <Alert message={error.data.message} type='error' />}
                <Form.Item>
                    <Button type='primary' htmlType='submit' block loading={isLoading}>
                        Create
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}


export default CreateOrganizationCard
